import { FC } from "react";
import { IResolveFATServiceOrderFormSchema } from "./schema";

const ProductInfoSummary: FC<{ data: IResolveFATServiceOrderFormSchema["productInfo"], values: IResolveFATServiceOrderFormSchema, }> = ({ data, values }) => (
  <div className="border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-md p-3 space-y-6 divide-y divide-gray-200">
    <div className=''>   
      <span className="text-xs font-light">Product Information</span>
      <div className='grid grid-cols-3 gap-6 mt-2'>
        <div className="col-span-1">
          <span className="block text-sm font-light text-gray-700">
            Product Type
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.type || "N/A"}
          </div>
        </div>
        <div className="col-span-2 col-start-1">
          <span className="block text-sm font-light text-gray-700">
            Description
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.description || "N/A"}
          </div>
        </div>
        <div className="col-span-1 col-start-1">
          <span className="block text-sm font-light text-gray-700">
            Sampling Technique
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.samplingTechnique || "N/A"}
          </div>
        </div>
        <div className="col-span-1">
          <span className="block text-sm font-light text-gray-700">
            Sampled Quantity
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.sampledQuantity || "N/A"}
          </div>
        </div>
        <div className="col-span-1">
          <span className="block text-sm font-light text-gray-700">
            Test Equipment
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.testEquipment || "N/A"}
          </div>
        </div>
        <div className="col-span-1">
          <span className="block text-sm font-light text-gray-700">
            Packaging
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.packaging || "N/A"}
          </div>
        </div>
        <div className="col-span-3">
          <span className="block text-sm font-light text-gray-700">
            Serial Numbers
          </span>
          <div className="mt-1 block w-full sm:text-sm">
            {data?.serialNumbers?.join(", ") || "N/A"}
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default ProductInfoSummary;